import { useEffect, useMemo }      from 'react'
import { useFetch }       from 'hooks/fetch/useFetch'
import { useSetAtom }     from 'state/jotai'
import { _bootstrap}      from 'state/store.bootstrap'
import { BOOT }           from 'api/api'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'

export const useFetch_Bootstrap = () => {
  const navigate            = useNavigate();
  const location            = useLocation();
  const { i18n:{language} } = useTranslation()
  const path                = location.pathname.split('/')

  const updateAtom   = useSetAtom(_bootstrap)
  const { D:data }   = useFetch({url:BOOT,file:'useFetch_Bootstrap.jsx'})
  
  const { Projects } = Object.keys(data || {}).length ? data : {};
  const state        = Object.keys(data || {}).length ? true : false

    const multipr = [[
 {
        "Language": "da",
        "Presentation": "Alle ejendomme",
        "URLSafe": "Isometry",
        "PID": "4,6,8,9,10,13",
        "path": "/isometry"
    },
    {
        "Language": "da",
        "Presentation": "Postillionen",
        "URLSafe": "postillionen",
        "PID": "4",
        "path": "/isometry/postillionen"
    },
    {
        "Language": "da",
        "Presentation": "Gyldenløve",
        "URLSafe": "gyldenlove",
        "PID": "6",
        "path": "/isometry/gyldenlove"
    },
    {
        "Language": "da",
        "Presentation": "Skibet",
        "URLSafe": "skibet",
        "PID": "8",
        "path": "/isometry/skibet"
    },
    {
        "Language": "da",
        "Presentation": "Broen",
        "URLSafe": "broen",
        "PID": "9",
        "path": "/isometry/broen"
    },
    {
        "Language": "da",
        "Presentation": "Hvide Falk",
        "URLSafe": "hvidefalk",
        "PID": "10",
        "path": "/isometry/hvidefalk"
    },
    {
        "Language": "da",
        "Presentation": "Dannebroge",
        "URLSafe": "dannebroge",
        "PID": "13",
        "path": "/isometry/dannebroge"
    }
  ]
]


  const projectDropdown = {};

  const projectLanguage = useMemo(() => {
    return data?.multiProjectOption
      ? [...new Set(data?.multiProjectOption[0]?.map(m => m.Language))]
      : [];
  }, [data]);

  useEffect(() => {
    
  // if the given path includes language which isn't proper then the page will redirect to default language path
  if (
    projectLanguage?.length &&
    !projectLanguage.includes(language)
  ) {
    navigate(`/${projectLanguage[0]}/${path.slice(2).join('/')}`, { replace: true });
  }
}, [projectLanguage]);
  



  // Multiproject dropdown adding as per different langauge 
  projectLanguage?.forEach(( lang ) => {

    projectDropdown[lang] = 
    data?.multiProjectOption[0]
    .filter((m) => m.Language === lang).map((p, i) => {
      let projectData = Projects?.filter((pr) => pr.ProjectID === p.PID)
      if(projectData?.length > 0) return { ...p, PIN: i, available_Units: projectData[0]?.NoOfVacantUnits }
      return { ...p, PIN: i}
    } )
  })
  
  useEffect(()=>{
    
    if ( data && Object.keys(data ?? {}).length ) {
      updateAtom({
        type        : data.HasMap ? 'poly' : 'mono',
        cdn         : data.CDNIsometry,
        openhouse   : data.ShowOpenHouseInfo,
        siteid      : data.SiteID,
        sitename    : data.SiteName,
        routes      : data.Router,
        startpage   : data.StartPage ?? `${projectLanguage?.[0] ?? 'da'}/isometry`,
        dropdown    : data.Dropdown,
        projectids  : [data?.ProjectIDs?.join(','), ...data?.ProjectIDs],
        // projectids  : [[data?.ProjectID]?.join(','), ...[data.ProjectID]],
        projectnames: { ...projectDropdown },
        languages   : projectLanguage?.length ? projectLanguage : data?.Languages,
        projects    : data.Projects
      })
    }
  },[data])

  return state

}
